module.exports = __webpack_public_path__ + "static/media/default.4d497801.svg";